import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: COLOR_PURPLE,
  },
  secondaryColor: {
    color: '#371777',
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    backgroundColor: COLOR_PURPLE,

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
  titleContent: {
    fontSize: 16,
    margin: 0,
    color: COLOR_PURPLE,
    fontWeight: 'Bold',
    marginBottom: theme.spacing(1),
  },
  title: {
    color: COLOR_PURPLE,
    fontSize: 28,
    fontFamily: 'Lato',
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  sectionImageGraphicalAbstract: {
    [theme.breakpoints.up('md')]: {
      height: 400,
    },
  },
}));
